import { getDeviceDate } from "@myvp/shared/src/clock/get-device-date"

export const getBrowserTimezone = () => {
  // oxlint-disable-next-line eslint-js/no-restricted-properties
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
  // NOTE: MYVC-46869 chrome returns "+00:00" for "GMT" OS setting which can be the default on some lambda test configurations.
  return timeZone === "+00:00" ? "UTC" : timeZone
}

export const getBrowserTimezoneGMT = (timezoneOffset?: number) => {
  const offsetNumber = timezoneOffset ?? getDeviceDate().getTimezoneOffset()
  const absoluteOffset = Math.abs(offsetNumber)
  const timezoneGMT =
    "GMT" +
    (offsetNumber < 0 ? "+" : "-") +
    Math.floor(absoluteOffset / 60)
      .toString()
      .padStart(2, "00") +
    ":" +
    (absoluteOffset % 60).toString().padStart(2, "00")
  return timezoneGMT
}
